module.exports = __webpack_public_path__ + "src/img/artist/work02_1.jpg?a45b56ca0b35c4bc7b77c201c391e0a5";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work02_1.jpg
// module id = 19
// module chunks = 0